import { render, staticRenderFns } from "./SpecialNeedsStudentApply.vue?vue&type=template&id=1b4bdd04&"
import script from "./SpecialNeedsStudentApply.vue?vue&type=script&lang=js&"
export * from "./SpecialNeedsStudentApply.vue?vue&type=script&lang=js&"
import style0 from "./SpecialNeedsStudentApply.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports